import React from "react";
import { object, string } from "yup";
import Helpers from "../../../commons/helpers";
import { IRole } from "../../../commons/interfaces";
import { Mode } from "../../../constants/enums";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";
import RoleService from "../../../services/identity/role.serice";
import useStrings from "../../useStrings";
import { IRoleError } from "./useData";

export const useSubmit = ({
    data,
    mode,
    onChangeMode,
    onGoBack,
    setError,
}: {
    data: IRole;
    mode: Mode;
    onChangeMode: (mode: Mode) => void;
    onGoBack: () => void;
    setError: React.Dispatch<React.SetStateAction<IRoleError>>;
}) => {
    const Strings = useStrings();
    const { clientId, userInfo, serviceCode, onError, onSuccess, onShowLoading, onHideLoading } = useCommonComponentContext();

    const schemaRequest = object({
        roleName: string().nullable().required(),
    });

    const onSubmit = async () => {
        try {
            if (mode === Mode.View) return onChangeMode(Mode.Update);
            onShowLoading();

            await schemaRequest.validate(data, { abortEarly: false });
            const request = {
                serviceCode: data?.serviceCode,
                status: data?.status,
                roleName: data?.roleName,
                type: data?.type,
                roleLevel: data?.roleLevel,
                description: data?.description,
                organizationId: data?.organizationId,
                id: data?.id,
                clientId: clientId,
                updateTime: data?.updateTime ? Number(data?.updateTime) : undefined,
                resources: data?.roleResourcePermissions,
            };

            if (Helpers.isNullOrEmpty(request?.id)) {
                delete request.updateTime;
                const result = await RoleService.create(request);
                onSuccess(Strings.Role.CREATE_SUCCESS);
            } else {
                const result = await RoleService.update(request);
                onSuccess(Strings.Role.UPDATE_SUCCESS);
            }

            onGoBack();
        } catch (error: any) {
            if (error.name === "ValidationError") {
                const newError: IRoleError = Helpers.handleValidationError(error);
                setError(newError);
            } else {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            }
        } finally {
            onHideLoading();
        }
    };

    return {
        onSubmit,
    };
};

export default useSubmit;
